import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { testId } from 'ui-components/services/testid-service';

import style from './style.module.less';

const errorMessage = {
  id: 'markAsShipped.errorMessage',
  defaultMessage: 'Carrier selection required to Mark as Shipped',
};

export default () => {
  return (
    <div className={style['error-wrapper']} {...testId('mark-as-shipped-error-message')}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <FormattedMessage {...errorMessage} />
    </div>
  );
};
